import React from 'react';

interface CustomCellProps {
  value?: unknown;
  render?: () => React.ReactNode;
}

function CustomCell({ value, render }: CustomCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  return <>{value as React.ReactNode}</>;
}

export default CustomCell;
